import { MessageBarType } from "@fluentui/react";
import { useState } from "react";
import { IDataResult, ResponseStatus, IResult } from "../../common/models/Result";
import { useForm } from "../../common/viewmodels/DefaultVM";
import { DataUtils } from "../../common/views/DataUtils";
import { AccountModel, AccountProvider, SignupModel } from "../models/AccountTypes";
import { AccountService } from "../services/AccountService";
import { accountCallback } from "./LoginVM";

export function useSignupVM() {
    const accountService = new AccountService();
    const [loading, setLoading] = useState(false);
    const [showConfirm, setShowConfirm] = useState(false);

    const { form, setField, resetForm, errorMessages, setErrorMessages,
        summaryText, setSummaryText, summaryType, setSummaryType
    } = useForm<SignupModel>({
        countryCode: "855",
        phoneNo: "",
        telegram: false,
        provider: AccountProvider.phone,
        email: "",
        password: "",
        rememberMe: false,
        firstName: "",
        lastName: "",
        displayName: "",
        isMobile: false,
        isLocal: false
    });

    const submit = (callback: (account: AccountModel) => void) => {
        setLoading(true);

        if (form.provider === AccountProvider.phone) {
            form.email = undefined;
        }

        setField("password", form.password.trim());
        setField("firstName", form.firstName.trim());
        setField("lastName", form.lastName.trim());
        setField("displayName", form.displayName.trim());

        const request = accountService.signup(form);

        DataUtils.onRequest(
            request,
            (result: IDataResult) => onSignupResult(result, callback)
        );
    }

    const onSignupResult = (result: IDataResult, callback: (account: AccountModel) => void) => {
        if (!result.errorMessages) result.errorMessages = {};
        var account = result.data as AccountModel;

        if (result.status === ResponseStatus.success) {
            onSuccess(account, callback);
        } else {
            onFail(result);
        }

        setLoading(false);
    }

    const onSuccess = (account: AccountModel, callback: accountCallback) => {
        callback(account);
        resetForm();
    }

    const onFail = (result: IDataResult) => {
        const res = result as IResult;

        if (res) {
            setErrorMessages(res.errorMessages);
            setSummaryText(res.summaryText ?? "");
            setSummaryType(res.summaryType ?? MessageBarType.info);
        }
    }

    return {
        errorMessages,
        summaryText,
        summaryType,
        form,
        setField,

        loading, setLoading,
        showConfirm, setShowConfirm,

        submit
    }
}